var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99998 0.833252C4.93748 0.833252 0.833313 4.93742 0.833313 9.99992C0.833313 15.0624 4.93748 19.1666 9.99998 19.1666C15.0625 19.1666 19.1666 15.0624 19.1666 9.99992C19.1666 4.93742 15.0625 0.833252 9.99998 0.833252ZM13.9733 8.44992C14.0465 8.36629 14.1022 8.26887 14.1371 8.16339C14.1721 8.05792 14.1856 7.94651 14.1769 7.83574C14.1681 7.72496 14.1373 7.61705 14.0863 7.51836C14.0352 7.41966 13.965 7.33217 13.8796 7.26104C13.7942 7.1899 13.6955 7.13655 13.5892 7.10414C13.4829 7.07172 13.3712 7.06089 13.2607 7.07227C13.1502 7.08366 13.043 7.11704 12.9456 7.17045C12.8482 7.22385 12.7624 7.29621 12.6933 7.38325L9.10998 11.6824L7.25581 9.82742C7.09864 9.67562 6.88814 9.59162 6.66964 9.59352C6.45115 9.59542 6.24214 9.68306 6.08763 9.83757C5.93312 9.99208 5.84548 10.2011 5.84358 10.4196C5.84169 10.6381 5.92568 10.8486 6.07748 11.0058L8.57748 13.5058C8.65936 13.5876 8.75739 13.6515 8.86532 13.6933C8.97326 13.7351 9.08873 13.754 9.20437 13.7488C9.32001 13.7435 9.43329 13.7142 9.53699 13.6628C9.64068 13.6113 9.73252 13.5388 9.80665 13.4499L13.9733 8.44992Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.74f382bd.svg";
export { ForwardRef as ReactComponent };